// useTweaks.js — Global tweak state persisted to localStorage
import React from "react";

const STORAGE_KEY = "ragross.tweaks";
const DEFAULTS = {
  lang: "es",
  displayFont: "space",
  animations: true,
  mode: "arcade",
  viewport: "desktop",
};

function load() {
  try {
    return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}") };
  } catch (e) {
    return { ...DEFAULTS };
  }
}

const listeners = new Set();
let state = load();

function persist() {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
}

export function setKey(key, value) {
  state = { ...state, [key]: value };
  persist();
  listeners.forEach((cb) => cb(state));
}

export function setMulti(obj) {
  state = { ...state, ...obj };
  persist();
  listeners.forEach((cb) => cb(state));
}

export function getState() { return state; }

export function useTweaks() {
  const [s, setS] = React.useState(state);
  React.useEffect(() => {
    const cb = (next) => setS(next);
    listeners.add(cb);
    return () => listeners.delete(cb);
  }, []);
  return [s, setKey, setMulti];
}
